import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MasterUrlService } from '../../regservices/SmasterUrl.service';
import { OPD_API_URL } from '../../regproperties/opd-url-properties';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppBaseService } from '../../services/http.service';
import { CriticalHealth } from '../../regmodels/MpatientRegistration';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiLanguageService } from '../../core/multi-language/multi-language.service';

@Component({
  selector: 'lib-critical-heilth-info',
  templateUrl: './critical-heilth-info.component.html',
  styleUrl: './critical-heilth-info.component.scss'
})
export class CriticalHeilthInfoComponent implements OnInit, OnDestroy {
  private subscriptionList = new Subscription();
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  conditionTypeMasterList: any[] = [];
  criticalHealthForm!: FormGroup;
  public cssClass: string = 'e-outline';
  isFocus:boolean = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { patientId: string ,rowData:CriticalHealth ,isUpdate :boolean,isViewOnly?:boolean},
    public dialogRef: MatDialogRef<CriticalHeilthInfoComponent>,
    private masterApiService: MasterUrlService,
    private fb: FormBuilder,
    private appBaseService: AppBaseService,
    public snackBar: MatSnackBar,
    private multiLangService:MultiLanguageService
  ) { }
  ngOnInit(): void {
    this.criticalHealthForm = this.fb.group({
    conditionType: [null],
    dateOfEntry: [null],
    description: ['']
  });
  if(this.data.isViewOnly){
    this.criticalHealthForm.disable();
  }
    this.getConditionMaster();
  }

  ngOnDestroy(): void {
    this._onDestroy.next(true);
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
  }
  getConditionMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_CONDITION_TYPE)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.conditionTypeMasterList = data;
        this.getRowsData();
      });
  }
  getRowsData(){
    if(this.data.rowData){
      const conditionType = this.conditionTypeMasterList.find(item => item.code === this.data.rowData.conditionType.code);
      this.criticalHealthForm.patchValue({
        conditionType: conditionType ? conditionType : null,
        dateOfEntry: new Date(this.data.rowData.createdOn * 1000),
        description: this.data.rowData.criticalHealthDetails
      });
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
  onSaveClick(){
    if(this.data.isUpdate){
      this.updateCriticalHealthInfo();
    }else{
      this.saveCriticalHealthInfo();
    }
  }
  saveCriticalHealthInfo() {
 if (this.criticalHealthForm.invalid) {
    this.criticalHealthForm.markAllAsTouched();
    return;
  }
  const formVal = this.criticalHealthForm.value;
  const payload = [
    {
      id: null,
      conditionType: this.multiLangService.createObjectList(formVal.conditionType),
      criticalHealthDetails: formVal.description,
      status: true,   
      reason: null,
      patientId:""
    }
  ];
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.appBaseService
        .postResource(OPD_API_URL.SAVE_CRITICAL_HEALTH +this.data.patientId, payload)
        .subscribe((res: any) => {
          this.snackBar.open("Condition details saved successfully","Success",{duration:2000});
          this.dialogRef.close("yes");
        }));

  }
  updateCriticalHealthInfo(){
    if (this.criticalHealthForm.invalid) {
      this.criticalHealthForm.markAllAsTouched();
      return;
    }
    const formVal = this.criticalHealthForm.value;
    const payload = {
      id: this.data.rowData.id,
      conditionType:this.multiLangService.createObjectList(formVal.conditionType),
      createdOn:0,
      criticalHealthDetails: formVal.description,
      status: this.data.rowData.status,
      patientId: this.data.patientId
    };
      this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
      this.subscriptionList.add(
        this.appBaseService
          .postResource(OPD_API_URL.UPDATE_CRITICAL_HEALTH , payload)
          .subscribe((res: any) => {
            this.snackBar.open("Condition details updated successfully","Success",{duration:2000});
            this.dialogRef.close("yes");
          }));
  }
}
